export const cashBoxListSelector = (state) => state.cashWarrant.cashBoxList;
export const cashBoxListStockSelector = (state) => state.cashWarrant.cashBoxListStock;
export const cashBoxListOrgSelector = (state) => state.cashWarrant.cashBoxListOrg;
export const cashWarrantStatus = (state) => state.cashWarrant.status;
